import React, { useEffect, useState, useContext } from "react";
// import { useParams, withRouter } from "react-router-dom";
import "./Resumelist.scss";
import { dateParcer } from "../../Utils/Dateparcer";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Shareresume from "../../Components/Shareresume/Shareresume";
import { Dropdown } from "react-bootstrap";
import Deleteresume from "../../Components/Deleteresume/Deleteresume";
import ReNameresume from "../../Components/RenamePopup/RenamePopup";
import { previewResume } from "../../Store/Actions/ResumeActions";
import { downloadCover } from "../../Store/Actions/CoverLetterActions";
import { userTypeContext } from "../../Context/FreeOrProContext";
import { ExternalUserContext } from "../../Context/externalUserContext";
import Profeature from "../Modals/ProFeatureModal/ProFeatureModal";
import axios from "axios";
import Editor from "../../Pages/Editor/Editor";
import CoverPreview from "../../Pages/CoverPreview/CoverPreview";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import Modal from "react-bootstrap/Modal";
import DownloadPopup from "../DownloadPopup/DownloadPopup";
import CoverEditor from "../../Pages/CoverEditor/Editor";
import Duplicateresume from "../Duplicateresume/Duplicateresume";

function Resumelist({
  resumedata,
  type,
  resume,
  cover,
  index,
  handleEditFunction,
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  //functions
  const [resumeExample, setResumeExample] = useState("");
  const baseurl = process.env.REACT_APP_API_URL;
  // const { userType, resumeCount } = useContext(userTypeContext);
  const {
    userType,
    resumeCount,
    coverCount,
    maxCount,
    showProPopup,
    setPopupType,
    setShowProPopup,
    popupType,
    showProPopupMessage,
    setShowProPopupMessage,
  } = useContext(userTypeContext);
  const { isLogin, setIsLogin } = useContext(ExternalUserContext);
  const path = window.location.pathname;

  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    isSample,
    setIsSample,
    coverJson,
    setCoverJson,
    isCoverJson,
    setIsCoverJson,
    isCoverSample,
    setIsCoverSample,
    jsonCoverIndex,
    setJsonCoverIndex,
  } = useContext(jsonEditorContext);
  const templateData = useSelector((state) => state.templateList.list);
  const coverTemplateData = useSelector((state) => state.CoverTemplates.list);

  const [show, setShow] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const handleEdit = (type, id) => {
    handleEditFunction(type, id);
    // setIsJson(false);
    // history.push(`/resumes/${id}`);
  };

  const [imageData, setImageData] = useState("");

  //   const coverEdit = (id) => {
  //     setIsJson(false);
  //     history.push(`/coverletter/${id}`);
  //   };

  //Sharereume popup
  const [shareShow, sharesetModalShow] = useState(false);
  const shareHide = () => sharesetModalShow(false);

  const sharemodal = () => {
    if (path && path.includes("create")) {
      setShowLogin(true);
    } else {
      if (userType && userType == "free") {
        let data = resumedata && resumedata.lockedFeatures;
        if (data && data.length > 0) {
          setShowProPopup(true);
          setPopupType("share");
          setShowProPopupMessage("Please upgrade to Pro");
        } else {
          sharesetModalShow(true);
        }
      } else {
        sharesetModalShow(true);
      }
    }
  };
  //Duplicate Popup
  const [showDuplicate, setShowDuplicate] = useState(false);

  const showDuplicatePopup = () => {
    setShowDuplicate(true);
  };

  const hideDuplicatePopup = () => {
    setShowDuplicate(false);
  };

  //Rename Popup
  const [renamePopup, setRenamePopup] = useState(false);

  const showResumePopup = () => {
    setRenamePopup(true);
  };

  const hideRenamePopup = () => {
    setRenamePopup(false);
  };

  //Modal Delete
  const [deletePopup, setDeletePopup] = useState(false);

  const showDeletePopup = () => {
    setDeletePopup(true);
  };

  const hidePopup = () => {
    setDeletePopup(false);
  };

  const resumeDownload = (id, type) => {
    if (type == "cover") {
      dispatch(downloadCover(id));
    } else {
      dispatch(previewResume(id));
    }
  };
  const resumeDownloadMail = (id, type) => {
    if (type == "cover") {
      if (isLogin && isLogin) {
        dispatch(downloadCover(id, "download"));
      } else {
        setShowLogin(true);
      }
    } else {
      if (isLogin && isLogin) {
        dispatch(previewResume(id, "download"));
      } else {
        setShowLogin(true);
      }
    }
  };

  const setHide = () => {
    setShow(false);
  };

  const pricing = () => {
    history.push("/pricingplansnew");
  };

  //Json Handle
  useEffect(() => {
    setIsJson(true);
    setIsCoverJson(true);

    if (type == "cover") {
      setCoverJson(resumedata);
      setJsonCoverIndex(index);
    } else {
      setJson(resumedata);
      setJsonIndex(index);
    }
  }, [resumedata, index]);
  const [modal, setModal] = useState(false);
  const handleToggle = () => {
    if (path && path.includes("create")) {
      setShowLogin(true);
    } else {
      if (userType && userType == "free") {
        let data = resumedata && resumedata.lockedFeatures;
        if (data && data.length > 0) {
          setShowProPopup(true);
          setPopupType("download");
          setShowProPopupMessage("Please upgrade to Pro");
        } else {
          setModal(!modal);
        }
      } else {
        setModal(!modal);
      }
    }
    // } setModal(!modal);
  };
  return (
    <>
      <Profeature show={show} hide={setHide} pricing={pricing} />
      {resumedata && resumedata.id && type && (
        <>
          <div className="resume-box">
            <div className="resume-container" style={{ height: "285px" }}>
              <div
                style={{
                  width: "200px",
                }}
              >
                {
                  type == "resume" && (
                    // templateData &&
                    // templateData.data &&
                    // templateData.data
                    //   .filter(
                    //     (x) =>
                    //       x.template_code ==
                    //       `${resumedata && resumedata.template_id}`
                    //   )
                    //   .map((data, index) => {
                    //     let image = JSON.parse(data.image);
                    //     return (
                    <div style={{ scale: "0.23", transformOrigin: "0px 0px" }}>
                      <Editor index={index} sample={true} preview={true} />
                    </div>
                  )
                  //   );
                  //   <img className="w-100" src={image.key} key={index} />
                  // })
                }
                {
                  type == "cover" && (
                    // coverTemplateData &&
                    // coverTemplateData &&
                    // coverTemplateData
                    //   .filter(
                    //     (x) =>
                    //       x.template_code ==
                    //       `${resumedata && resumedata.template_id}`
                    //   )
                    //   .map((data) => {
                    //     let image = JSON.parse(data.image);
                    //     return (
                    <div style={{ scale: "0.23", transformOrigin: "0px 0px" }}>
                      <CoverEditor index={index} sample={true} preview={true} />
                    </div>
                  )
                  //   );
                  // })
                }
              </div>

              {/* <img
                src={resumedata.thumb}
                style={{
                  position: "absolute",
                  width: "100%",
                }}
              /> */}
              <div className="actionbtns">
                {type == "cover" ? (
                  <>
                    <button
                      className="btn primarybtn"
                      onClick={() => handleEdit("cover", resumedata.id)}
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/edit-pencil.png`}
                        alt="resumeedit"
                        className="mr-2"
                        style={{ maxWidth: "17px" }}
                      />
                      Edit
                    </button>
                    <button
                      className="btn primarybtn mt-2 home-download-button"
                      onClick={handleToggle}
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/download.svg`}
                        alt="resumeedit"
                        className="mr-2"
                      />
                      Download
                    </button>

                    <button
                      className="btn primarybtn mt-2 home-share-button"
                      onClick={sharemodal}
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/share.svg`}
                        alt="resumeedit"
                        className="mr-2"
                      />
                      Share
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="btn primarybtn mt-2"
                      onClick={() => handleEdit("resume", resumedata.id)}
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/edit-pencil.png`}
                        alt="resumeedit"
                        className="mr-2"
                        style={{ maxWidth: "17px" }}
                      />
                      Edit
                    </button>

                    <button
                      className="btn primarybtn mt-2 home-download-button"
                      onClick={handleToggle}
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/download.svg`}
                        alt="resumeedit"
                        className="mr-2 "
                      />
                      Download
                    </button>

                    <button
                      className="btn primarybtn mt-2 home-share-button"
                      onClick={sharemodal}
                      // onClick={() => resumeEdit(resumedata.id)}
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/share.svg`}
                        alt="resumeedit"
                        className="mr-2"
                      />
                      Share
                    </button>
                  </>
                )}
              </div>
              <div className="overlaybtn"></div>
            </div>
            <div className="d-flex justify-content-between home-resume-name-div mt-3 mb-2">
              <div className="w-100" style={{ textOverflow: "ellipsis" }}>
                <h6
                  data-toggle="tooltip"
                  data-placement="bottom"
                  data-custom-classname="tooltip-success"
                  title={resumedata.title}
                  className="resume-title text-capitalize"
                >
                  {resumedata.title}
                </h6>
                <p className="updatedate">
                  {dateParcer(resumedata.updated_at)}
                </p>
              </div>
              <div>
                <Dropdown className="p-0">
                  <Dropdown.Toggle id="resume-drpdown">
                    <img
                      src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/more.svg`}
                      alt="more"
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={showResumePopup}>
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/edit-pencil.png`}
                        alt="edit"
                        style={{ maxWidth: "15px", marginRight: "10px" }}
                      />
                      Rename
                    </Dropdown.Item>
                    <Dropdown.Item onClick={showDuplicatePopup}>
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/edit-pencil.png`}
                        alt="edit"
                        style={{ maxWidth: "15px", marginRight: "10px" }}
                      />
                      Duplicate
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={handleToggle}
                      className="home-threedot-download"
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/download.svg`}
                        alt="trash"
                        style={{ maxWidth: "17px", marginRight: "10px" }}
                      />
                      Download
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={sharemodal}
                      className="home-threedot-share"
                    >
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/share.svg`}
                        alt="trash"
                        style={{ maxWidth: "17px", marginRight: "10px" }}
                      />
                      Share
                    </Dropdown.Item>
                    <Dropdown.Item onClick={showDeletePopup}>
                      <img
                        src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/trash.svg`}
                        alt="trash"
                        style={{ maxWidth: "17px", marginRight: "10px" }}
                      />
                      Delete
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <Shareresume
            show={shareShow}
            shareHide={shareHide}
            resumeId={resumedata && resumedata.random_code}
            cover={type}
          />

          <Deleteresume
            deleteId={resumedata.id}
            deleteResume={deletePopup}
            hideResume={hidePopup}
            page="home"
            cover={type}
          />
          <Duplicateresume
            show={showDuplicate}
            cover={"cover"}
            duplicateHide={hideDuplicatePopup}
            resume={resumedata}
          />
          {modal && modal && (
            <DownloadPopup
              show={modal}
              handleToggle={handleToggle}
              type={type}
              id={resumedata.id}
              resumedata={resumedata}
            />
          )}
          {renamePopup && (
            <ReNameresume
              cover={type}
              name={resumedata && resumedata.title}
              resumeId={resumedata.id}
              renameResume={renamePopup}
              hideResume={hideRenamePopup}
            />
          )}
        </>
      )}
    </>
  );
}

export default Resumelist;
